import { isInternalAccountingEnabled } from "@/shared/config/runtime";

export const MOBILE_LAUNCH_URL = {
  vehicle_rental: (id: number) => `/api/legal/vehicle-rentals/${id}/mobile-submit-for-signing/`,
  premises_lease: (id: number) => `/api/legal/premises-leases/${id}/mobile-submit-for-signing/`,
  service_agreement_individual: (id: number) =>
    `/api/legal/service-agreements-individual/${id}/mobile-submit-for-signing/`,
  service_agreement_msb: (id: number) =>
    `/api/legal/service-agreements-msb/${id}/mobile-submit-for-signing/`,
  goods_supply: (id: number) => `/api/legal/goods-supply/${id}/mobile-submit-for-signing/`,
  vehicle_handover: (id: number) => `/api/legal/vehicle-handovers/${id}/mobile-submit-for-signing/`,
  premises_handover: (id: number) =>
    `/api/legal/premises-handovers/${id}/mobile-submit-for-signing/`,
  platform_access: (id: number) => `/api/legal/platform-access/${id}/mobile-submit-for-signing/`,
  completion_act: (id: number) => `/api/legal/completion-acts/${id}/mobile-submit-for-signing/`,
  custom_document: (id: number) => `/api/legal/custom-documents/${id}/mobile-submit-for-signing/`,
  targeted_financing: (id: number) =>
    `/api/legal/targeted-financing/${id}/mobile-submit-for-signing/`,
  contract_draft: (id: number) => `/api/hr/contracts/${id}/mobile-submit-for-signing/`,
  job_application: (candidateId: number) =>
    `/api/hr/candidates/${candidateId}/mobile-sign-job-application/`,
  hiring_order: (id: number) => `/api/hr/orders-on-hiring/${id}/mobile-sign/`,
  annual_leave: (id: number) => `/api/hr/annual-leaves/${id}/mobile-approve/`,
  unpaid_leave: (id: number) => `/api/hr/unpaid-leaves/${id}/mobile-approve/`,
  resignation_letter: (id: number) => `/api/hr/resignation-letters/${id}/mobile-approve/`,
  vacation_order: (id: number) => `/api/hr/vacation-orders/${id}/mobile-sign/`,
  termination_order: (id: number) => `/api/hr/termination-orders/${id}/mobile-sign/`,
  amendment_application: (id: number) => `/api/hr/amendments/${id}/mobile-approve/`,
  amendment_agreement: (id: number) => `/api/hr/amendments/${id}/mobile-submit-agreement/`,
  amendment_order: (id: number) => `/api/hr/amendment-orders/${id}/mobile-sign/`,
  business_trip_order: (tripId: number) => `/api/hr/business-trip-orders/${tripId}/mobile-sign/`,
  personal_sheet: () => "/api/self/personal-sheet/mobile-sign/",
  interest_free_loan: (id: number) =>
    `/api/accounting/income-records/${id}/mobile-submit-for-signing/`,
  irrevocable_contribution: (id: number) =>
    `/api/accounting/income-records/${id}/mobile-submit-for-signing/`,
  salary_advance: (id: number) => `/api/self/advance/${id}/mobile-submit-for-signing/`,
} as const;

export const SALARY_ADVANCE_MOBILE_CREATE_URL = "/api/self/advance/salary/mobile-create-and-sign/";

export const ABORT_SIGNING_URL = {
  vehicle_rental: (id: number) => `/api/legal/vehicle-rentals/${id}/abort-signing/`,
  premises_lease: (id: number) => `/api/legal/premises-leases/${id}/abort-signing/`,
  service_agreement_individual: (id: number) =>
    `/api/legal/service-agreements-individual/${id}/abort-signing/`,
  service_agreement_msb: (id: number) => `/api/legal/service-agreements-msb/${id}/abort-signing/`,
  goods_supply: (id: number) => `/api/legal/goods-supply/${id}/abort-signing/`,
  vehicle_handover: (id: number) => `/api/legal/vehicle-handovers/${id}/abort-signing/`,
  premises_handover: (id: number) => `/api/legal/premises-handovers/${id}/abort-signing/`,
  platform_access: (id: number) => `/api/legal/platform-access/${id}/abort-signing/`,
  completion_act: (id: number) => `/api/legal/completion-acts/${id}/abort-signing/`,
  custom_document: (id: number) => `/api/legal/custom-documents/${id}/abort-signing/`,
  targeted_financing: (id: number) => `/api/legal/targeted-financing/${id}/abort-signing/`,
  annual_leave: (id: number) => `/api/hr/annual-leaves/${id}/abort-signing/`,
  unpaid_leave: (id: number) => `/api/hr/unpaid-leaves/${id}/abort-signing/`,
} as const;

export const CANCEL_SIGNING_URL = {
  hiring_order: (id: number) => `/api/hr/orders-on-hiring/${id}/cancel-signing/`,
  vacation_order: (id: number) => `/api/hr/vacation-orders/${id}/cancel-signing/`,
  termination_order: (id: number) => `/api/hr/termination-orders/${id}/cancel-signing/`,
  amendment_order: (id: number) => `/api/hr/amendment-orders/${id}/cancel-signing/`,
  business_trip_order: (tripId: number) => `/api/hr/business-trip-orders/${tripId}/cancel-signing/`,
  job_application: (candidateId: number) => `/api/hr/candidates/${candidateId}/cancel-job-application-signing/`,
  personal_sheet: () => "/api/self/personal-sheet/cancel-signing/",
  salary_advance: (id: number) => `/api/self/advance/${id}/cancel-signing/`,
} as const;

export const MOBILE_SIGNING_UNSUPPORTED = ["medical_leave", "medical_leave_order"] as const;

export const ACCOUNTING_OWNED_SOURCE_TYPES = [
  "interest_free_loan",
  "irrevocable_contribution",
] as const;

export type MobileLaunchSourceType = keyof typeof MOBILE_LAUNCH_URL;
export type AbortSigningSourceType = keyof typeof ABORT_SIGNING_URL;

export function isMobileSigningSupported(sourceType: string): boolean {
  if (MOBILE_SIGNING_UNSUPPORTED.includes(sourceType as (typeof MOBILE_SIGNING_UNSUPPORTED)[number])) {
    return false;
  }
  if (
    !isInternalAccountingEnabled &&
    ACCOUNTING_OWNED_SOURCE_TYPES.includes(sourceType as (typeof ACCOUNTING_OWNED_SOURCE_TYPES)[number])
  ) {
    return false;
  }
  return sourceType in MOBILE_LAUNCH_URL;
}
